

export function NotPermittedView() {

  return (
    <div className="not-permitted-view">
      <h1>Not Permitted</h1>
      <p>You are not permitted to view this page.</p>
    </div>
  );
}